function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "grc-logo-b",
  cx: 20.009,
  cy: 19.537,
  r: 19.488
}), /*#__PURE__*/React.createElement("filter", {
  id: "grc-logo-a",
  width: "305.3%",
  height: "305.3%",
  x: "-102.6%",
  y: "-51.3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 20,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.145098039 0 0 0 0 0.0588235294 0 0 0 0 0.541176471 0 0 0 0.2 0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-c",
  x1: "105.995%",
  x2: "-17.154%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-d",
  x1: "160.915%",
  x2: "-31.06%",
  y1: "92.502%",
  y2: "9.12%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-e",
  x1: "102%",
  x2: "48.931%",
  y1: "67.326%",
  y2: "33.245%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-f",
  x1: "28.272%",
  x2: "82.506%",
  y1: "-1.078%",
  y2: "84.249%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-g",
  x1: "50.006%",
  x2: "50.006%",
  y1: "17.445%",
  y2: "78.838%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "grc-logo-h",
  x1: "0%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#18BBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#0E4284"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(11.71 .292)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#grc-logo-a)",
  xlinkHref: "#grc-logo-b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#grc-logo-b"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-c)",
  fillRule: "nonzero",
  d: "M19.95 21.874h5.754L27.1 19.45h-8.512z",
  transform: "translate(11.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-d)",
  fillRule: "nonzero",
  d: "M22.64 21.874l-1.412 2.446 1.53 2.654 2.704-4.683 1.638-2.84z",
  transform: "translate(11.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-e)",
  fillRule: "nonzero",
  d: "M20.149 13.098l-10.62.002 5.314 9.196 5.31 9.196 1.51-2.615-1.915-3.39-2.578-4.463-2.982-5.16 5.96-.002 5.961-.002-.881 1.528h3.061l2.479-4.295z",
  transform: "translate(11.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-f)",
  fillRule: "nonzero",
  d: "M24.29 24.298h-3.062l4.002 7.023 1.707-2.374z",
  transform: "translate(11.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-g)",
  fillRule: "nonzero",
  d: "M33.249 24.745a14.128 14.128 0 1 1 .549-8.944h2.776c-1.828-8.22-9.45-13.823-17.842-13.115-8.391.708-14.967 7.51-15.392 15.92-.425 8.41 5.433 15.84 13.71 17.39 8.277 1.55 16.425-3.257 19.073-11.25h-2.874z",
  transform: "translate(11.71 .292)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#grc-logo-h)",
  fillRule: "nonzero",
  d: "M26.109 15.86H14.196L9.53 13.1h21.238z",
  transform: "translate(11.71 .292)"
}));

const SvgGrcLogo = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 52,
    viewBox: "0 0 67 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrcLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grc-logo.4a8186ae.svg";
export { ForwardRef as ReactComponent };